import AccountInfoComponent from './AccountInfo';
import NavComponent from './Nav';
import RulesComponent from './Rules';
import ConfigComponent from './Config';
import KnowledgeBaseConfigComponent from './KnowledgeBaseConfig';
import AddBotComponent from './AddBot';
import BannerComponent from './Banner';
import HomeCardComponent from './HomeCard';
import AnalyticsComponent from './Analytics';
import FeatureToggleComponent from './FeatureToggle';
import ServerToServerToggleComponent from './ServerToServerToggle';
import LocalizationComponent from './Localization';
import AgentAssistHomeCardComponent from './AgentAssistHomeCard';

export const AccountInfo = AccountInfoComponent;
export const Nav = NavComponent;
export const Rules = RulesComponent;
export const Config = ConfigComponent;
export const KnowledgeBaseConfig = KnowledgeBaseConfigComponent;
export const AddBot = AddBotComponent;
export const Banner = BannerComponent;
export const HomeCard = HomeCardComponent;
export const AgentAssistHomeCard = AgentAssistHomeCardComponent;
export const Analytics = AnalyticsComponent;
export const FeatureToggle = FeatureToggleComponent;
export const ServerToServerToggle = ServerToServerToggleComponent;
export const Localization = LocalizationComponent;
